import { useEffect, useState } from "react";
import { apiClient } from "../App";

const BADGE_STYLES = {
  Elite: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Strong: "bg-sky-100 text-sky-700 border-sky-200",
  Mixed: "bg-amber-100 text-amber-700 border-amber-200",
  Risk: "bg-red-100 text-red-700 border-red-200",
  "N/A": "bg-slate-100 text-slate-500 border-slate-200",
};

export default function RetentionQualityBlock({ endpoint, testId = "retention-quality" }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!endpoint) return;
    apiClient.get(endpoint)
      .then(r => { if (!cancelled) setData(r.data); })
      .catch(() => { if (!cancelled) setErr(true); });
    return () => { cancelled = true; };
  }, [endpoint]);

  if (err) return null;
  if (!data) return <div className="text-xs text-slate-400" data-testid={`${testId}-loading`}>Loading retention quality…</div>;
  if (data.total === 0) return null;

  const badge = data.qualityBadge || "N/A";
  const pill = BADGE_STYLES[badge] || BADGE_STYLES["N/A"];

  return (
    <div className="rounded-md border border-slate-200 bg-white p-3" data-testid={testId}>
      <div className="flex items-center justify-between mb-2">
        <div className="text-[11px] uppercase text-slate-500">Retention Quality</div>
        <span className={`text-[11px] px-2 py-0.5 rounded-full border font-medium ${pill}`} data-testid={`${testId}-badge`}>
          {badge}
        </span>
      </div>
      <div className="grid grid-cols-5 gap-2 text-center">
        <div>
          <div className="text-sm font-semibold text-slate-900">{data.cancellationPct}%</div>
          <div className="text-[10px] text-slate-500 uppercase">Cancellation</div>
        </div>
        <div>
          <div className="text-sm font-semibold text-slate-900">{data.paymentFailedPct}%</div>
          <div className="text-[10px] text-slate-500 uppercase">Payment Failed</div>
        </div>
        <div>
          <div className="text-sm font-semibold text-emerald-600">{data.activePayerPct}%</div>
          <div className="text-[10px] text-slate-500 uppercase">Active Payer</div>
        </div>
        <div>
          <div className="text-sm font-semibold text-slate-900">£{data.avgValue}</div>
          <div className="text-[10px] text-slate-500 uppercase">Avg Value</div>
        </div>
        <div>
          <div className="text-sm font-semibold text-amber-600">{data.giftAidPct}%</div>
          <div className="text-[10px] text-slate-500 uppercase">Gift Aid</div>
        </div>
      </div>
    </div>
  );
}
